import { Icon, Layout, Text } from '@loadsmart/miranda-react'

export function DocumentEmptyState() {
  return (
    <Layout.Group
      data-testid="document-empty-state"
      justify="flex-start"
      align="center"
      gap="spacing-1"
    >
      <Icon size="small" name="clock" color="color-text-placeholder" />
      <Text variant="body-sm" color="color-text-placeholder">
        Waiting for documents
      </Text>
    </Layout.Group>
  )
}
